import {lazy} from '@aboutyou/lazy-imports';

export const DiscoverCategory = lazy(() =>
  import('./DiscoverCategory.eager').then(mod => ({
    default: mod.DiscoverCategory,
  })),
);
